import {
  GET_MY_WALLETS,
  GET_MY_TRANSACTIONS,
  TOPUP_MY_WALLET,
  ADMIN_GET_CUSTOMER_WALLETS,
  ADMIN_GET_CUSTOMER_TRANSACTIONS,
  ADMIN_CREATE_WALLETS,
  ADMIN_CREATE_CUSTOM_WALLET,
  ADMIN_TOPUP_WALLET,
  ADMIN_TERMINATE_WALLET,
  ADMIN_LIST_PLANS,
  ADMIN_CREATE_PLAN,
  ADMIN_UPDATE_PLAN,
  ADMIN_DELETE_PLAN,
  ADMIN_CHANGE_SUBSCRIPTION,
  ADMIN_GET_SUBSCRIPTION,
  ADMIN_GET_BILLING_SETUP,
  ADMIN_RUN_BILLING_SETUP,
  ADMIN_EDIT_WALLET,
  ADMIN_VOID_WALLET_CREDITS,
} from '../lib/constant';

const initialState = {
  myWallets: null,
  myTransactions: null,
  topUpResponse: null,
  adminWallets: null,
  adminTransactions: null,
  adminCreateWalletsResponse: null,
  adminCreateCustomWalletResponse: null,
  adminTopUpResponse: null,
  adminTerminateWalletResponse: null,
  adminPlans: null,
  adminCreatePlanResponse: null,
  adminUpdatePlanResponse: null,
  adminDeletePlanResponse: null,
  adminSubscription: null,
  adminChangeSubscriptionResponse: null,
  adminBillingSetup: null,
  adminRunBillingSetupResponse: null,
  adminEditWalletResponse: null,
  adminVoidWalletCreditsResponse: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MY_WALLETS:
      return { ...state, myWallets: action.payload };
    case GET_MY_TRANSACTIONS:
      return { ...state, myTransactions: action.payload };
    case TOPUP_MY_WALLET:
      return { ...state, topUpResponse: action.payload };
    case ADMIN_GET_CUSTOMER_WALLETS:
      return { ...state, adminWallets: action.payload };
    case ADMIN_GET_CUSTOMER_TRANSACTIONS:
      return { ...state, adminTransactions: action.payload };
    case ADMIN_CREATE_WALLETS:
      return { ...state, adminCreateWalletsResponse: action.payload };
    case ADMIN_CREATE_CUSTOM_WALLET:
      return { ...state, adminCreateCustomWalletResponse: action.payload };
    case ADMIN_TOPUP_WALLET:
      return { ...state, adminTopUpResponse: action.payload };
    case ADMIN_TERMINATE_WALLET:
      return { ...state, adminTerminateWalletResponse: action.payload };
    case ADMIN_LIST_PLANS:
      return { ...state, adminPlans: action.payload };
    case ADMIN_CREATE_PLAN:
      return { ...state, adminCreatePlanResponse: action.payload };
    case ADMIN_UPDATE_PLAN:
      return { ...state, adminUpdatePlanResponse: action.payload };
    case ADMIN_DELETE_PLAN:
      return { ...state, adminDeletePlanResponse: action.payload };
    case ADMIN_EDIT_WALLET:
      return { ...state, adminEditWalletResponse: action.payload };
    case ADMIN_GET_SUBSCRIPTION:
      return { ...state, adminSubscription: action.payload };
    case ADMIN_CHANGE_SUBSCRIPTION:
      return { ...state, adminChangeSubscriptionResponse: action.payload };
    case ADMIN_GET_BILLING_SETUP:
      return { ...state, adminBillingSetup: action.payload };
    case ADMIN_RUN_BILLING_SETUP:
      return { ...state, adminRunBillingSetupResponse: action.payload };
    case ADMIN_VOID_WALLET_CREDITS:
      return { ...state, adminVoidWalletCreditsResponse: action.payload };
    default:
      return state;
  }
}
